import { Toast, Dialog, Notify } from "vant";
import { Message, MessageBox, Notification } from "element-ui";
import { Hc_IsMobile } from "@/tools/hc";

const isMobile = Hc_IsMobile();

/* ================= Toast ================= */
const hcToast = {
  success(msg) {
    isMobile ? Toast.success(msg) : Message.success(msg);
  },
  error(msg) {
    isMobile ? Toast.fail(msg) : Message.error(msg);
  },
  warning(msg) {
    isMobile ? Toast(msg) : Message.warning(msg);
  },
  info(msg) {
    isMobile ? Toast(msg) : Message.info(msg);
  },
  loading(msg = "加载中...") {
    if (isMobile) {
      Toast.loading({
        message: msg,
        forbidClick: true,
        duration: 0,
      });
    }
  },
  clear() {
    isMobile && Toast.clear();
  },
};

/* ================= Confirm ================= */
function hcConfirm(options, defaultTitle) {
  let opts = {};

  if (typeof options === "string") {
    opts.message = options;
    opts.title = defaultTitle || "提示";
  } else {
    opts = options || {};
  }

  const { message, title = "提示", confirmText = "确定", cancelText = "取消", type = "warning" } = opts;

  return new Promise((resolve, reject) => {
    if (isMobile) {
      Dialog.confirm({
        title,
        message,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
      })
        .then(resolve)
        .catch(reject);
    } else {
      MessageBox.confirm(message, title, {
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        type,
      })
        .then(resolve)
        .catch(reject);
    }
  });
}

/* ================= Notify（防刷屏） ================= */
const notifyCache = new Map();

function canNotify(key, gap = 2000) {
  const now = Date.now();
  const last = notifyCache.get(key) || 0;
  if (now - last < gap) return false;
  notifyCache.set(key, now);
  return true;
}

const typeMap = {
  success: { vant: "success", element: "success" },
  error: { vant: "danger", element: "error" },
  warning: { vant: "warning", element: "warning" },
  info: { vant: "primary", element: "info" },
};

const hcNotify = {
  show(type, message, options = {}) {
    const { duration = 3000, key = `${type}:${message}`, gap = 2000 } = options;

    if (!canNotify(key, gap)) return;

    if (isMobile) {
      Notify({
        type: typeMap[type].vant,
        message,
        duration,
      });
    } else {
      Notification({
        type: typeMap[type].element,
        message,
        duration,
      });
    }
  },

  success(msg, opts) {
    this.show("success", msg, opts);
  },
  error(msg, opts) {
    this.show("error", msg, {
      key: "global-error",
      ...opts,
    });
  },
  warning(msg, opts) {
    this.show("warning", msg, opts);
  },
  info(msg, opts) {
    this.show("info", msg, opts);
  },
};

/* ================= Plugin ================= */
export default {
  install(Vue) {
    Vue.prototype.$hcToast = hcToast;
    Vue.prototype.$hcConfirm = hcConfirm;
    Vue.prototype.$hcNotify = hcNotify;
  },
};

export { hcNotify };



// WEBPACK FOOTER //
// ./src/plugins/hc-ui.js